<loading-spinner [show]="isLoadingAPI" [config]="loaderConfig" [isAPIBased]="true"></loading-spinner>
